import { useTranslation } from "react-i18next";

import type { OrgUnitDecision } from "@/api/diagnostic-org-structure";

/** A decisão de escopo como a tela a nomeia; Pendente é a ausência de decisão. */
export type DecisionView = OrgUnitDecision | "pending";

/** Cores do protótipo para cada decisão; Pendente é o branco com borda. */
export const DECISION_STYLE: Record<DecisionView, string> = {
  in_scope: "border-[#bfe5cc] bg-[#e7f6ec] text-[#1e7b43]",
  client_validation: "border-[#f5d98f] bg-[#fff4d6] text-[#8a5a00]",
  out_of_scope: "border-[#d4dae3] bg-[#eef1f5] text-[#596b85]",
  pending: "border-[#d4dae3] bg-white text-[#596b85]",
};

export function useDecisionLabels(): Record<DecisionView, string> {
  const { t } = useTranslation();
  return {
    in_scope: t("In scope"),
    client_validation: t("Validate with client"),
    out_of_scope: t("Out of scope"),
    pending: t("Pending"),
  };
}
